import { NgZone } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { installHorizontalWheelScroll } from './app/horizontal-wheel-scroll';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    // Rueda → scroll horizontal en contenedores `.custom-scrollbar`. Fuera de la zona de Angular:
    // sus `mouseover`/`wheel` no deben disparar detección de cambios.
    appRef.injector.get(NgZone).runOutsideAngular(() => installHorizontalWheelScroll());
  })
  .catch((err) => console.error(err));
